<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>NorsupOne</title>
  </head>
  <body>
    <div class="container-fluid">
      <div class="row gx-0">
        <div class="col-lg-12 d-flex">
          <div class="">
            <app-side-bar></app-side-bar>
          </div>
          <div class="right-side">
            <div class="pt-3">
              <div class="glass-bg w-100">
                <div class="installer-tab pt-4">
                  <ul class="nav" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        (click)="viewChange(true)">
                        Installers
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        (click)="viewChange(false)">
                        Unverified Installers
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab">
                      <div class="d-flex pb-4 pt-2 px-3 title-cell-block">
                        <div class="flex-grow-1">
                          <div class="title-cell">
                            <div class="d-flex bd-highlight w-100">
                              <div class="p-2 flex-grow-1 bd-highlight">
                                <div class="d-flex search-cell">
                                  <div class="search-container">
                                    <form
                                      action
                                      method="get"
                                      (ngSubmit)="search(searchTerm)">
                                      <input
                                        class="search expandright"
                                        id="searchright"
                                        type="search"
                                        [(ngModel)]="searchTerm"
                                        name="searchTerm"
                                        placeholder="Search"
                                        (input)="onInput()" />
                                      <label
                                        class="button searchbutton"
                                        for="searchright"><span
                                          class="mglass">&#9906;</span></label>
                                    </form>
                                  </div>
                                </div>
                              </div>
                              <div class="p-1 bd-highlight">
                                <div class="dropdown">
                                  <button
                                    class="sorting-btn"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    {{selectedCountry()}}
                                    <span *ngIf="selectedCountry().toLocaleLowerCase() == 'country'"class="dropdown-toggle"></span>
                                    <span *ngIf="selectedCountry().toLocaleLowerCase() != 'country'" class="btn-close btn-close-white remove-filter" (click)="remove_filter()"></span>
                                  </button>
                                  <ul
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1">
                                    <li *ngFor="let timezone of timezone_list">
                                      <a 
                                        class="dropdown-item"
                                        (click)="
                                          timezoneAndStatusFilter(timezone)
                                        ">{{ timezone }}</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="p-1 bd-highlight">
                                <div class="dropdown">
                                  <button
                                    class="sorting-btn"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    {{selectedStatus()}}
                                    <span *ngIf="selectedStatus().toLocaleLowerCase().includes('status')"class="dropdown-toggle"></span>
                                    <span *ngIf="selectedStatus().toLocaleLowerCase().includes('tive')" class="btn-close btn-close-white remove-filter" (click)="remove_filter()"></span>
                                  </button>
                                  <ul
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1">
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="
                                          timezoneAndStatusFilter(
                                            'Active',
                                            false
                                          )
                                        ">Active</a>
                                    </li>
                                    <li>
                                      <a
                                        class="dropdown-item"
                                        (click)="
                                          timezoneAndStatusFilter(
                                            'Inactive',
                                            false
                                          )
                                        ">Inactive</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="wrapper row gx-0">
                        <div class="loader-container" *ngIf="isLoading">
                          <span class="loader"></span>
                        </div>
                      </div>
                      <div>
                        <span *ngIf="noResult()"
                        ><i class="fa fa-ban no-result-icon" aria-hidden="true"></i
                      ></span>
                    </div>
                    <div>
                      <span class="search-result no-result-content " *ngIf="noResult()"
                        >NO RESULTS FOUND</span>
                      </div>
                      <div class="" *ngIf="!noResult()">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="user-type user-table-list">
                              <div class="table-list rounded">
                                <ng-container style="border: None">
                                  <table class="table table-dark table-hover">
                                    <caption hidden="true">
                                      INSTALLER LIST
                                    </caption>
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          class="name name-heading">
                                          Name
                                        </th>
                                        <th
                                          scope="col"
                                          class="table-view table-view-heading">
                                          Country&nbsp;<img
                                            src="assets/img/country.svg" 
                                            alt="country" />
                                        </th>
                                        <th
                                          scope="col"
                                          class="table-view table-view-heading">
                                          Activation Status
                                        </th>
                                        <th
                                          scope="col"
                                          class="table-view table-view-heading">
                                          Email address
                                        </th>
                                        <th
                                        scope="col"
                                        class="table-view table-view-heading">
                                        Installer Status
                                      </th>

                                      </tr>
                                    </thead>
                                    <tbody
                                      *ngFor="let installer of paginatedInfo; index as i">
                                      <tr>
                                        <td class="name"
                                          style="cursor: pointer;"
                                          (click)="installerView(installer)">
                                          <a data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"
                                            *ngIf="installer.Status == 'Inactive'"><img
                                              [src]="getUserImage(installer.files_id)"
                                              alt="hugenerd"
                                              width="40"
                                              height="40"
                                              class="rounded-circle image"
                                              (click)="installerView(installer)" />
                                            {{
                                            getTrimmedFullName(installer.firstname,
                                            installer.lastname) }}
                                          </a>
                                          <a
                                            *ngIf="installer.Status == 'Active'"><img
                                              [src]="getUserImage(installer.files_id)"
                                              alt="hugenerd"
                                              width="40"
                                              height="40"
                                              class="rounded-circle active-image"
                                              (click)="installerView(installer)" />
                                            {{
                                            getTrimmedFullName(installer.firstname,
                                            installer.lastname) }}
                                          </a>
                                        </td>
                                        <td
                                          class="table-view"
                                          style="cursor: pointer">
                                          {{ installer.timezone }}
                                        </td>
                                        <td class="table-view user_active" *ngIf="!isApiCalling(installer.user_id)">
                                          <input
                                          id="toggle-button"
                                          *ngIf = "!isApiCalling(installer.user_id)"
                                          type="checkbox"
                                          [checked]="installer.Status === 'Active'"
                                          (change)="updateStatus(installer,i)"
                                        />        
                                        </td>
                                        <td *ngIf="isApiCalling(installer.user_id)" class="table-view loader-center"><span *ngIf="isApiCalling(installer.user_id)" class="loader"></span></td>
                                        <td class="table-view">
                                          <span>{{ installer.username }}</span>
                                        </td>


                                        <td class="table-view user_active" *ngIf="!isApiCalling(installer.user_id)">
                                          


                                      <ul class='tg-list'>
                                        <li class='tg-list-item'>
                                          <label class='tgl-btn' for="{{'cb3'+i}}"></label>

                                          <button class='tgl tgl-skewed' id="{{'cb3'+i}}" type='' *ngIf = "!isApiCalling(installer.user_id) "  (click)="onStatusChange(installer,i,installer.verification_status)" [ngClass]="{'red-button': installer.verification_status === 'False'}"></button>

                                          <label class="tgl-btn" 
                                          [attr.data-tg-on]="installer.verification_status === 'True' ? '&uarr; Verified' : '&darr; Unverified'" 
                                          [attr.data-tg-off]="installer.verification_status === 'False' ? '&darr; Unverified' : '&uarr; Verified'" 
                                          for="{{'cb3'+i}}"></label>
                                          <label class='tgl-btn' for="{{'cb3'+i}}"> 
                                          </label>

                                        </li>
                                      </ul>
                                    </td>
                                    <td *ngIf="isApiCalling(installer.user_id)" class="table-view loader-center"><span *ngIf="isApiCalling(installer.user_id)" class="loader"></span></td>


                                      </tr>
                                    </tbody>
                                  </table>
                                </ng-container>
                              </div>
                            </div>
                            <div
                              class="text-center d-flex justify-content-center dashboard-pagination">
                              <ng-container *ngIf="installer_list">
                                <ngb-pagination
                                  [(page)]="currentPage"
                                  [pageSize]="itemsPerPage"
                                  [collectionSize]="installer_list.length"
                                  (pageChange)="pageChanged($event)"
                                  style="z-index: 0"></ngb-pagination>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"></h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="status-info text-center">
          <img src="assets/img/info.svg" width="50" 
          alt="info"/>
          <h5 class="text-white pt-3">This installer is currently inactive!</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-light btn-sm"
          data-bs-dismiss="modal"
          (click)="popUpClose()">
          OK
        </button>
      </div>
    </div>
  </div>
</div>
